var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgImageIcon = function SvgImageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.264.5c.92 0 1.666.746 1.666 1.667v16.666c0 .92-.746 1.667-1.666 1.667H2.597c-.92 0-1.667-.746-1.667-1.667V2.167C.93 1.247 1.676.5 2.597.5h16.667zm-5.19 10.47-5.112 6.133a.834.834 0 0 1-1.21.075l-.07-.075-2.326-2.79-2.76 3.31v1.21h16.668v-1.65l-.078-.08-5.112-6.134zm5.19-8.803H2.597V15.02l2.119-2.542a.834.834 0 0 1 1.21-.075l.07.075 2.325 2.79 5.113-6.135a.834.834 0 0 1 1.21-.074l.07.074 4.55 5.459V2.167zM8.43 5.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z"
  })));
};

export default SvgImageIcon;